import { render, staticRenderFns } from "./SectionPropertyList.vue?vue&type=template&id=4506804e"
import script from "./SectionPropertyList.vue?vue&type=script&lang=js"
export * from "./SectionPropertyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports